module.exports = __webpack_public_path__ + "static/media/ot_5.2ce36585.JPG";